import React, { useState, useEffect, useRef } from "react";
import { Routes, Route, useLocation, useSearchParams, data } from 'react-router-dom';
import Select from 'react-select';
// import axios from "axios";
import './Personaldetails.css';
import RegistrationNavbar from "../EmployeeRegistartion/RegistrationNavbar";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { selectStyleDisable, selectStyles } from "../../../../../../assets/Styles/selectStyle";
import { getReservationCategory, getNationalities, getReligions, getGenders, getMaritalStatuses, personalDetailsSubmit, getEmployeeDetailsBasedonEmployeeUniqueeId } from "../../../../../../services/employeeCreationService";
import { validateEmail, capitalizeFirstLetter, isAlphabet, onlyDigits, validateMobile } from "../../../../../../utils/validations";
import { getAuditLog } from "../../../../../../utils/calculateDaysInMonthUtils";

const PersonalDetails = ({ onNext }) => {

  const effectRan = useRef(false);
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const employeeUniqueId =
    searchParams.get('employeeUniqueId') ||           // 1. URL param
    location.state?.applicationId;                // 2. navigate state

  const [personalData, setPersonalData] = useState({
    employeeUniqueId: "",
    surName: "",
    employeeName: "",
    gender: "",
    dateOfBirth: "",
    contactNumber: "",
    emailAddress: "",
    maritalStatus: "",
    nationality: "",
    religion: "",
    category: "",
    hearingProblem: "",
    isCreamyLayer: "",
    visualProblem: "",
    physicallyHandicapped: "",
    wifeName: "",
    wifeSurname: "",
    wifeContactNumber: "",
    husbandName: "",
    husbandSurname: "",
    husbandContactNumber: "",
    fatherGivenName: "",
    fatherSurname: "",
    fatherContactNumber: "",
    motherGivenName: "",
    motherSurname: "",
    motherContactNumber: "",
  });
  const [errors, setErrors] = useState({
    surName: '',
    employeeName: '',
    gender: '',
    dateOfBirth: '',
    contactNumber: '',
    emailAddress: '',
    maritalStatus: '',
    nationality: '',
    isCreamyLayer: "",
    religion: '',
    category: '',
    hearingProblem: '',
    visualProblem: '',
    physicallyHandicapped: '',
    wifeName: '',
    wifeSurname: '',
    wifeContactNumber: '',
    husbandName: '',
    husbandSurname: '',
    husbandContactNumber: '',
    fatherGivenName: '',
    fatherSurname: '',
    fatherContactNumber: '',
    motherGivenName: '',
    motherSurname: '',
    motherContactNumber: '',
  });
  const [categories, setCategories] = useState([]);
  const [nationalities, setNationalities] = useState([]);
  const [religions, setReligions] = useState([]);
  const [genders, setGenders] = useState([]);
  const [maritalStatuses, setMaritalStatuses] = useState([]);
  const [isFormValid, setIsFormValid] = useState(false);
  const [isFocused, setIsFocused] = useState({
    gender: false,
    maritalStatus: false,
    nationality: false,
    religion: false,
    category: false,
    dateOfBirth: false,
  });
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const dateInputRef = useRef(null);
  const [completed, setCompleted] = useState(false);   // <-- NEW
  const isFieldDisabled = completed;               // simple case
  // OR, if you still want name fields disabled even when not completed:
  // const isFieldDisabled = completed || true;    // always disabled
  // Fetch personal info
  useEffect(() => {
    const fetchPersonalInfo = async () => {
      if (employeeUniqueId) {
        try {
          // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/personal-info/${employeeUniqueId}`);
          // const data = response.data;
          const data = await getEmployeeDetailsBasedonEmployeeUniqueeId(employeeUniqueId);
          console.log('API Response:', data);
          setPersonalData({
            employeeUniqueId: data.employeeUniqueId || "",
            surName: data.surname || "",
            employeeName: data.givenName || "",
            gender: data.gender?.id ? Number(data.gender.id) : "",
            dateOfBirth: data.dateOfBirth || "",
            contactNumber: data.contactNumber || "",
            emailAddress: data.email || "",
            maritalStatus: data.maritalStatus?.id ? Number(data.maritalStatus.id) : "",
            nationality: data.nationality?.id ? Number(data.nationality.id) : "",
            religion: data.religion?.id ? Number(data.religion.id) : "",
            category: data.reservationCategory?.id ? Number(data.reservationCategory.id) : "",
            hearingProblem: String(data.hearingProblem ?? ""),
            visualProblem: String(data.visualProblem ?? ""),
            isCreamyLayer: String(data.isCreamyLayer ?? ""),
            physicallyHandicapped: String(data.physicallyHandicapped ?? ""),
            wifeName: data.spouseName && data.gender?.id === 1 ? data.spouseName : "",
            wifeSurname: data.spouseSurname && data.gender?.id === 1 ? data.spouseSurname : "",
            wifeContactNumber: data.spouseContactNumber && data.gender?.id === 1 ? data.spouseContactNumber : "",
            husbandName: data.spouseName && data.gender?.id === 2 ? data.spouseName : "",
            husbandSurname: data.spouseSurname && data.gender?.id === 2 ? data.spouseSurname : "",
            husbandContactNumber: data.spouseContactNumber && data.gender?.id === 2 ? data.spouseContactNumber : "",
            fatherGivenName: data.fatherGivenName || "",
            fatherSurname: data.fatherSurname || "",
            fatherContactNumber: data.fatherContactNumber || "",
            motherGivenName: data.motherGivenName || "",
            motherSurname: data.motherSurname || "",
            motherContactNumber: data.motherContactNumber || "",
          });
          setCompleted(data.completed === true);   // <-- NEW
          setIsDataLoaded(true);
        } catch (error) {
          console.error('Error fetching personal info:', error);
        }
      }
    };
    if (effectRan.current === false) {
      fetchPersonalInfo();
    }
    return () => {
      effectRan.current = true;
    }
  }, [employeeUniqueId]);

  // Fetch dropdown options
  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const [
          categoriesData,
          nationalitiesData,
          religionsData,
          gendersData,
          maritalStatusesData
        ] = await Promise.all([
          getReservationCategory(),
          getNationalities(),
          getReligions(),
          getGenders(),
          getMaritalStatuses()
        ]);
        // const sortedData=data=>data.sort((a,b)=>a.categoryName.localeCompare(b.categoryName))
        // .map(cat=>({
        //   value: cat.id,
        //   label: cat.categoryName
        // }));
        // setCategories(sortedData(categoriesData));

        setCategories(categoriesData.map(cat => ({
          value: cat.id,
          label: cat.categoryName
        })));

        setNationalities(nationalitiesData.map(nat => ({
          value: nat.id,
          label: nat.nationalityName
        })));

        setReligions(religionsData.map(reg => ({
          value: reg.id,
          label: reg.religionName
        })));

        setGenders(gendersData.map(g => ({
          value: g.id,
          label: g.gender
        })));

        setMaritalStatuses(maritalStatusesData.map(m => ({
          value: m.id,
          label: m.maritalStatus
        })));
      } catch (error) {
        console.error('Error fetching dropdown data:', error);
      }
    };

    if (effectRan.current === false) {
      fetchAllData();
    }
    return () => {
      effectRan.current = true;
    }

  }, []);

  // Save to localStorage
  useEffect(() => {
    if (isDataLoaded) {
      localStorage.setItem('personalData', JSON.stringify(personalData));
      console.log('Saved to localStorage:', personalData);
    }
  }, [personalData, isDataLoaded]);

  // Load from localStorage if no employeeUniqueId
  useEffect(() => {
    const savedData = localStorage.getItem("personalData");
    if (savedData && !employeeUniqueId) {
      const parsedData = JSON.parse(savedData);
      setPersonalData({
        ...personalData,
        ...parsedData,
        nationality: parsedData.nationality ? Number(parsedData.nationality) : '',
        religion: parsedData.religion ? Number(parsedData.religion) : '',
        category: parsedData.category ? Number(parsedData.category) : '',
        maritalStatus: parsedData.maritalStatus ? Number(parsedData.maritalStatus) : '',
        gender: parsedData.gender ? Number(parsedData.gender) : '',
        physicallyHandicapped: String(parsedData.physicallyHandicapped || ''),
        hearingProblem: String(parsedData.hearingProblem || ''),
        visualProblem: String(parsedData.visualProblem || ''),
        isCreamyLayer: String(parsedData.isCreamyLayer || ""),
      });
      setIsDataLoaded(true);
    }
  }, []);

  // Form validation
  // useEffect(() => {
  // if (
  //   !genders.length ||
  //   !maritalStatuses.length ||
  //   !nationalities.length ||
  //   !categories.length ||
  //   !religions.length
  // ) {
  //   setIsFormValid(false);
  //   return;
  // }

  //   const validate = () => {
  //     let formErrors = {};
  //     let isValid = true;

  //     if (!personalData.surName.trim()) {
  //       formErrors.surName = 'Surname is required';
  //       isValid = false;
  //     }
  //     if (!personalData.employeeName.trim()) {
  //       formErrors.employeeName = 'Employee Name is required';
  //       isValid = false;
  //     }
  //     if (!personalData.dateOfBirth.trim()) {
  //       formErrors.dateOfBirth = 'Date of Birth is required';
  //       isValid = false;
  //     }
  //     if (!personalData.contactNumber) {
  //       formErrors.contactNumber = 'Contact Number is required';
  //       isValid = false;
  //     } else if (!/^\d{10}$/.test(personalData.contactNumber)) {
  //       formErrors.contactNumber = 'Contact Number must be a 10-digit number';
  //       isValid = false;
  //     }
  //     if (!personalData.emailAddress.trim()) {
  //       formErrors.emailAddress = 'Email Address is required';
  //       isValid = false;
  //     } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(personalData.emailAddress)) {
  //       formErrors.emailAddress = 'Invalid email format';
  //       isValid = false;
  //     }
  //     if (!personalData.nationality) {
  //       formErrors.nationality = 'Nationality is required';
  //       isValid = false;
  //     }
  //     if (!personalData.category) {
  //       formErrors.category = 'Reservation Category is required';
  //       isValid = false;
  //     }
  //     if (!personalData.religion) {
  //       formErrors.religion = 'Religion is required';
  //       isValid = false;
  //     }
  //     if (!personalData.maritalStatus) {
  //       formErrors.maritalStatus = 'Marital Status is required';
  //       isValid = false;
  //     }
  //     if (!personalData.gender) {
  //       formErrors.gender = 'Gender is required';
  //       isValid = false;
  //     }
  //     if (!personalData.fatherGivenName.trim()) {
  //       formErrors.fatherGivenName = 'Father Given Name is required';
  //       isValid = false;
  //     }
  //     if (!personalData.fatherSurname.trim()) {
  //       formErrors.fatherSurname = 'Father Surname is required';
  //       isValid = false;
  //     }
  //     if (!personalData.motherGivenName.trim()) {
  //       formErrors.motherGivenName = 'Mother Given Name is required';
  //       isValid = false;
  //     }
  //     if (!personalData.motherSurname.trim()) {
  //       formErrors.motherSurname = 'Mother Surname is required';
  //       isValid = false;
  //     }

  //     // Validate that at least one of fatherContactNumber, motherContactNumber, or spouseContactNumber is provided
  //     const isFatherContactValid = personalData.fatherContactNumber && /^\d{10}$/.test(personalData.fatherContactNumber);
  //     const isMotherContactValid = personalData.motherContactNumber && /^\d{10}$/.test(personalData.motherContactNumber);
  //     const isMaleAndMarried = personalData.gender && personalData.maritalStatus &&
  //       genders.find(opt => opt.value === personalData.gender)?.label === 'Male' &&
  //       maritalStatuses.find(opt => opt.value === personalData.maritalStatus)?.label === 'Married';
  //     const isFemaleAndMarried = personalData.gender && personalData.maritalStatus &&
  //       genders.find(opt => opt.value === personalData.gender)?.label === 'Female' &&
  //       maritalStatuses.find(opt => opt.value === personalData.maritalStatus)?.label === 'Married';
  //     const isSpouseContactValid = (isMaleAndMarried && personalData.wifeContactNumber && /^\d{10}$/.test(personalData.wifeContactNumber)) ||
  //       (isFemaleAndMarried && personalData.husbandContactNumber && /^\d{10}$/.test(personalData.husbandContactNumber));

  //     if (!isFatherContactValid && !isMotherContactValid && !isSpouseContactValid) {
  //       formErrors.fatherContactNumber = 'At least one of Father, Mother, or Spouse Contact Number is required';
  //       formErrors.motherContactNumber = 'At least one of Father, Mother, or Spouse Contact Number is required';
  //       if (isMaleAndMarried) {
  //         formErrors.wifeContactNumber = 'At least one of Father, Mother, or Spouse Contact Number is required';
  //       } else if (isFemaleAndMarried) {
  //         formErrors.husbandContactNumber = 'At least one of Father, Mother, or Spouse Contact Number is required';
  //       }
  //       isValid = false;
  //     } else {
  //       formErrors.fatherContactNumber = '';
  //       formErrors.motherContactNumber = '';
  //       formErrors.wifeContactNumber = '';
  //       formErrors.husbandContactNumber = '';
  //       if (personalData.fatherContactNumber && !/^\d{10}$/.test(personalData.fatherContactNumber)) {
  //         formErrors.fatherContactNumber = 'Father Contact Number must be a 10-digit number';
  //         isValid = false;
  //       }
  //       else if (!validateMobile(personalData.fatherContactNumber)) {
  //           formErrors.fatherContactNumber = 'Contact Number must start with 6, 7, 8, or 9 and be 10 digits long';
  //           isValid = false;
  //       }
  //       if (personalData.motherContactNumber && !/^\d{10}$/.test(personalData.motherContactNumber)) {
  //         formErrors.motherContactNumber = 'Mother Contact Number must be a 10-digit number';
  //         isValid = false;
  //       }
  //       else if (!validateMobile(personalData.motherContactNumber)) {
  //                   formErrors.motherContactNumber = 'Contact Number must start with 6, 7, 8, or 9 and be 10 digits long';
  //                   isValid = false;
  //               }
  //       if (isMaleAndMarried && personalData.wifeContactNumber && !/^\d{10}$/.test(personalData.wifeContactNumber)) {
  //         formErrors.wifeContactNumber = 'Wife Contact Number must be a 10-digit number';
  //         isValid = false;
  //       }
  //        else if (!validateMobile(personalData.wifeContactNumber)) {
  //           formErrors.wifeContactNumber = 'Contact Number must start with 6, 7, 8, or 9 and be 10 digits long';
  //           isValid = false;
  //       }
  //       if (isFemaleAndMarried && personalData.husbandContactNumber && !/^\d{10}$/.test(personalData.husbandContactNumber)) {
  //         formErrors.husbandContactNumber = 'Husband Contact Number must be a 10-digit number';
  //         isValid = false;
  //       }
  //       else if (!validateMobile(personalData.husbandContactNumber)) {
  //           formErrors.husbandContactNumber = 'Contact Number must start with 6, 7, 8, or 9 and be 10 digits long';
  //           isValid = false;
  //       }
  //     }

  //     if (isMaleAndMarried) {
  //       if (!personalData.wifeName.trim()) {
  //         formErrors.wifeName = 'Wife Given Name is required';
  //         isValid = false;
  //       }
  //       if (!personalData.wifeSurname.trim()) {
  //         formErrors.wifeSurname = 'Wife Surname is required';
  //         isValid = false;
  //       }
  //     }
  //     if (isFemaleAndMarried) {
  //       if (!personalData.husbandName.trim()) {
  //         formErrors.husbandName = 'Husband Name is required';
  //         isValid = false;
  //       }
  //       if (!personalData.husbandSurname.trim()) {
  //         formErrors.husbandSurname = 'Husband Surname is required';
  //         isValid = false;
  //       }
  //     }

  //     console.log('Validation Errors:', formErrors, 'Is Valid:', isValid);
  //     setErrors(formErrors);
  //     setIsFormValid(isValid);
  //   };

  //   validate();
  // }, [personalData, genders, maritalStatuses, nationalities, categories, religions]);
  useEffect(() => {
    validateForm();
  }, [personalData, genders, maritalStatuses, nationalities, categories, religions, isDataLoaded]);
  // Handle input changes
  const handleInputChange = (eOrOption, fieldName) => {
    if (eOrOption && eOrOption.target) {
      const { name, value } = eOrOption.target;
      setPersonalData(prev => ({
        ...prev,
        [name]: value,
      }));
      if (name === "employeeName") {
        localStorage.setItem("employeeName", value);
      }
    } else {
      const value = eOrOption ? Number(eOrOption.value) : '';
      setPersonalData(prev => ({
        ...prev,
        [fieldName]: value,
      }));
    }
  };

  // Capitalize first letter of words
  // const capitalizeFirstLetter = (str) => {
  //   if (!str) return "";
  //   return str
  //     .split(" ")
  //     .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
  //     .join(" ");
  // };

  // Handle submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      alert('At least one of Father, Mother, or Spouse Contact Number is required');
      console.log('Validation failed on submit:', errors);
      return;
    }

    const fullName = localStorage.getItem("full_name");
    const role = localStorage.getItem("role");
    const employeeId = localStorage.getItem("employeeId");

    const isMaleAndMarried = personalData.gender && personalData.maritalStatus &&
      genders.find(opt => opt.value === personalData.gender)?.label === 'Male' &&
      maritalStatuses.find(opt => opt.value === personalData.maritalStatus)?.label === 'Married';
    const isFemaleAndMarried = personalData.gender && personalData.maritalStatus &&
      genders.find(opt => opt.value === personalData.gender)?.label === 'Female' &&
      maritalStatuses.find(opt => opt.value === personalData.maritalStatus)?.label === 'Married';

    const personalInformation = {
      surname: personalData.surName || null,
      givenName: personalData.employeeName || null,
      gender: personalData.gender ? { id: Number(personalData.gender) } : null,
      dateOfBirth: personalData.dateOfBirth || null,
      maritalStatus: personalData.maritalStatus ? { id: Number(personalData.maritalStatus) } : null,
      nationality: personalData.nationality ? { id: Number(personalData.nationality) } : null,
      religion: personalData.religion ? { id: Number(personalData.religion) } : null,
      reservationCategory: personalData.category ? { id: Number(personalData.category) } : null,
      contactNumber: personalData.contactNumber || null,
      email: personalData.emailAddress || null,
      isCreamyLayer: personalData.isCreamyLayer === "true" || personalData.isCreamyLayer === true,
      physicallyHandicapped: personalData.physicallyHandicapped === "true" || personalData.physicallyHandicapped === true,
      hearingProblem: personalData.hearingProblem === "true" || personalData.hearingProblem === true,
      visualProblem: personalData.visualProblem === "true" || personalData.visualProblem === true,
      spouseName: isMaleAndMarried ? personalData.wifeName : isFemaleAndMarried ? personalData.husbandName : null,
      spouseSurname: isMaleAndMarried ? personalData.wifeSurname : isFemaleAndMarried ? personalData.husbandSurname : null,
      spouseContactNumber: isMaleAndMarried ? personalData.wifeContactNumber : isFemaleAndMarried ? personalData.husbandContactNumber : null,
      fatherGivenName: personalData.fatherGivenName || null,
      fatherSurname: personalData.fatherSurname || null,
      fatherContactNumber: personalData.fatherContactNumber || null,
      motherGivenName: personalData.motherGivenName || null,
      motherSurname: personalData.motherSurname || null,
      motherContactNumber: personalData.motherContactNumber || null,
    };

    if (personalData.employeeUniqueId) {
      personalInformation.employeeUniqueId = Number(personalData.employeeUniqueId);
    }

    const payload = { personalInformation };

    if (employeeId && role) {
      // payload.auditLog = {
      //   name: fullName || '',
      //   role,
      //   employeeId,
      // };
      payload.auditLog = getAuditLog();
    }

    try {
      // const response = await axios.patch(`${process.env.REACT_APP_API_BASE_URL}/api/personal-info`, payload, {
      //   headers: {
      //     'Content-Type': 'application/json',
      //   },
      // });
      const response = await personalDetailsSubmit(payload);
      console.log('Server response:', response.data);
      const { employeeId: responseEmployeeId } = response.data;
      localStorage.setItem('personalData', JSON.stringify(personalData));
      onNext(responseEmployeeId);
    } catch (error) {
      console.error('Failed to submit data:', error);
      alert('Failed to save data. Please try again.');
    }
  };

  // Validate form (called on submit)
  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    // Required field validations
    if (!personalData.surName.trim()) { formErrors.surName = 'Surname is required'; isValid = false; }
    if (!personalData.employeeName.trim()) { formErrors.employeeName = 'Employee Name is required'; isValid = false; }
    if (!personalData.dateOfBirth) { formErrors.dateOfBirth = 'Date of Birth is required'; isValid = false; }
    if (!personalData.contactNumber || !/^\d{10}$/.test(personalData.contactNumber)) {
      formErrors.contactNumber = 'Contact Number must be a 10-digit number'; isValid = false;
    }
    if (!personalData.emailAddress.trim() || !validateEmail(personalData.emailAddress)) {
      formErrors.emailAddress = 'Valid Email is required'; isValid = false;
    }
    if (!personalData.nationality) { formErrors.nationality = 'Nationality is required'; isValid = false; }
    if (!personalData.category) { formErrors.category = 'Reservation Category is required'; isValid = false; }
    if (!personalData.religion) { formErrors.religion = 'Religion is required'; isValid = false; }
    if (!personalData.maritalStatus) { formErrors.maritalStatus = 'Marital Status is required'; isValid = false; }
    if (!personalData.gender) { formErrors.gender = 'Gender is required'; isValid = false; }
    if (!personalData.fatherGivenName.trim()) { formErrors.fatherGivenName = 'Father Given Name is required'; isValid = false; }
    if (!personalData.fatherSurname.trim()) { formErrors.fatherSurname = 'Father Surname is required'; isValid = false; }
    if (!personalData.motherGivenName.trim()) { formErrors.motherGivenName = 'Mother Given Name is required'; isValid = false; }
    if (!personalData.motherSurname.trim()) { formErrors.motherSurname = 'Mother Surname is required'; isValid = false; }

    // === SPOUSE VALIDATION ===
    const isMaleAndMarried = personalData.gender && personalData.maritalStatus &&
      genders.find(g => g.value === personalData.gender)?.label === 'Male' &&
      maritalStatuses.find(m => m.value === personalData.maritalStatus)?.label === 'Married';

    const isFemaleAndMarried = personalData.gender && personalData.maritalStatus &&
      genders.find(g => g.value === personalData.gender)?.label === 'Female' &&
      maritalStatuses.find(m => m.value === personalData.maritalStatus)?.label === 'Married';

    if (isMaleAndMarried) {
      if (!personalData.wifeName?.trim()) { formErrors.wifeName = 'Wife Given Name is required'; isValid = false; }
      if (!personalData.wifeSurname?.trim()) { formErrors.wifeSurname = 'Wife Surname is required'; isValid = false; }
    }

    if (isFemaleAndMarried) {
      if (!personalData.husbandName?.trim()) { formErrors.husbandName = 'Husband Name is required'; isValid = false; }
      if (!personalData.husbandSurname?.trim()) { formErrors.husbandSurname = 'Husband Surname is required'; isValid = false; }
    }

    // === CONTACT NUMBER VALIDATION (AT LEAST ONE) ===
    const fatherValid = personalData.fatherContactNumber && /^\d{10}$/.test(personalData.fatherContactNumber) && validateMobile(personalData.fatherContactNumber);
    const motherValid = personalData.motherContactNumber && /^\d{10}$/.test(personalData.motherContactNumber) && validateMobile(personalData.motherContactNumber);
    const wifeValid = isMaleAndMarried && personalData.wifeContactNumber && /^\d{10}$/.test(personalData.wifeContactNumber) && validateMobile(personalData.wifeContactNumber);
    const husbandValid = isFemaleAndMarried && personalData.husbandContactNumber && /^\d{10}$/.test(personalData.husbandContactNumber) && validateMobile(personalData.husbandContactNumber);

    const hasAtLeastOneContact = fatherValid || motherValid || wifeValid || husbandValid;

    if (!hasAtLeastOneContact) {
      const errorMsg = 'Contact Number of Father / Mother / Spouse is Required';
      formErrors.fatherContactNumber = errorMsg;
      formErrors.motherContactNumber = errorMsg;
      if (isMaleAndMarried) formErrors.wifeContactNumber = errorMsg;
      if (isFemaleAndMarried) formErrors.husbandContactNumber = errorMsg;
      isValid = false;
    } else {
      // Clear cross-field errors
      delete formErrors.fatherContactNumber;
      delete formErrors.motherContactNumber;
      delete formErrors.wifeContactNumber;
      delete formErrors.husbandContactNumber;

      // Individual format checks (only if field is filled)
      if (personalData.fatherContactNumber && !/^\d{10}$/.test(personalData.fatherContactNumber)) {
        formErrors.fatherContactNumber = 'Must be 10 digits'; isValid = false;
      } else if (personalData.fatherContactNumber && !validateMobile(personalData.fatherContactNumber)) {
        formErrors.fatherContactNumber = 'Must start with 6,7,8,9'; isValid = false;
      }

      if (personalData.motherContactNumber && !/^\d{10}$/.test(personalData.motherContactNumber)) {
        formErrors.motherContactNumber = 'Must be 10 digits'; isValid = false;
      } else if (personalData.motherContactNumber && !validateMobile(personalData.motherContactNumber)) {
        formErrors.motherContactNumber = 'Must start with 6,7,8,9'; isValid = false;
      }

      if (isMaleAndMarried && personalData.wifeContactNumber && !/^\d{10}$/.test(personalData.wifeContactNumber)) {
        formErrors.wifeContactNumber = 'Must be 10 digits'; isValid = false;
      } else if (isMaleAndMarried && personalData.wifeContactNumber && !validateMobile(personalData.wifeContactNumber)) {
        formErrors.wifeContactNumber = 'Must start with 6,7,8,9'; isValid = false;
      }

      if (isFemaleAndMarried && personalData.husbandContactNumber && !/^\d{10}$/.test(personalData.husbandContactNumber)) {
        formErrors.husbandContactNumber = 'Must be 10 digits'; isValid = false;
      } else if (isFemaleAndMarried && personalData.husbandContactNumber && !validateMobile(personalData.husbandContactNumber)) {
        formErrors.husbandContactNumber = 'Must start with 6,7,8,9'; isValid = false;
      }
    }
    // === NEW: NON CREAMY LAYER VALIDATION (Only for BC/EBC categories) ===
    const creamyLayerCategories = ['BC', 'BC-I', 'BC-II', 'EBC', 'EBC-I', 'EBC-II'];
    const selectedCategoryObj = categories.find(cat => cat.value === personalData.category);
    const selectedCategoryLabel = selectedCategoryObj?.label?.toUpperCase();

    const isCreamyLayerApplicable = selectedCategoryLabel && creamyLayerCategories.includes(selectedCategoryLabel);

    if (isCreamyLayerApplicable) {
      if (personalData.isCreamyLayer === "" || personalData.isCreamyLayer === null || personalData.isCreamyLayer === undefined) {
        formErrors.isCreamyLayer = 'Non Creamy Layer selection is required';
        isValid = false;
      }
    }
    // If not applicable → clear any old error
    else {
      delete formErrors.isCreamyLayer;
    }
    setErrors(formErrors);
    setIsFormValid(isValid);
    return isValid;
  };
  const currentYear = new Date().getFullYear();
  const minDate = new Date(1965, 0, 1).toISOString().split('T')[0];
  const today = new Date();
  const maxDate = today.toISOString().split('T')[0];

  const isMaleAndMarried = personalData.gender && personalData.maritalStatus &&
    genders.find(opt => opt.value === personalData.gender)?.label === 'Male' &&
    maritalStatuses.find(opt => opt.value === personalData.maritalStatus)?.label === 'Married';
  const isFemaleAndMarried = personalData.gender && personalData.maritalStatus &&
    genders.find(opt => opt.value === personalData.gender)?.label === 'Female' &&
    maritalStatuses.find(opt => opt.value === personalData.maritalStatus)?.label === 'Married';

  return (
    <React.Fragment>
      <div className="personaldetails-container">
        <Routes>
          <Route path="/registrationnavbar" element={<RegistrationNavbar />} />
        </Routes>
        <div className="personaldetails-box">
          <div className="pendingdetails-heading">
            <span className="highlight-label">Temporary ID:</span> {employeeUniqueId} - {personalData.employeeName} {personalData.surName}
          </div>
          <h2 className="personaldetails-heading">Personal Details</h2>
          <form onSubmit={handleSubmit}>
            <div className="personaldetails-maincontainer">
              <div className="personaldetails-container-part">
                <div className="personaldetails-floating-label-container-2">
                  <input
                    type="text"
                    name="employeeName"
                    value={personalData.employeeName}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (isAlphabet(value)) {
                        const updatedValue = capitalizeFirstLetter(value);
                        handleInputChange({ target: { name: "employeeName", value: updatedValue } });
                      }
                    }}
                    placeholder=" "
                    required
                    disabled
                  />
                  <label><span className="required">*</span>Given Name</label>
                  {errors.employeeName && <p className="error">{errors.employeeName}</p>}
                </div>
              </div>
              <div className="personaldetails-container-part">
                <div className="personaldetails-floating-label-container-1">
                  <input
                    type="text"
                    name="surName"
                    value={personalData.surName}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (isAlphabet(value)) {
                        const updatedValue = capitalizeFirstLetter(value);
                        handleInputChange({ target: { name: "surName", value: updatedValue } });
                      }
                    }}
                    placeholder=" "
                    required
                    disabled
                  />
                  <label><span className="required">*</span>Surname</label>
                  {errors.surName && <p className="error">{errors.surName}</p>}
                </div>
              </div>
            </div>
            <div className="personaldetails-maincontainer">
              <div className="personaldetails-container-part">
                <div className={`personaldetails-floating-label-container-2 ${isFocused.gender || !!personalData.gender ? 'float-label' : ''}`}>
                  <Select
                    name="gender"
                    options={genders}
                    value={genders.find(opt => opt.value === personalData.gender) || null}
                    onChange={(selectedOption) => handleInputChange(selectedOption, 'gender')}
                    onFocus={() => setIsFocused(prev => ({ ...prev, gender: true }))}
                    onBlur={() => setIsFocused(prev => ({ ...prev, gender: false }))}
                    placeholder=" "
                    isClearable
                    isDisabled // Removed for testing
                    // styles={{
                    //   menuPortal: base => ({ ...base, zIndex: 9999, position: 'absolute', top: 'auto', bottom: '100%' }),
                    //   menu: base => ({ ...base, marginTop: '5px', zIndex: 9999 }),
                    //   control: (provided, state) => ({
                    //     ...provided, padding: '1px', backgroundColor: state.isDisabled ? '#e4e4e4' : 'white',
                    //     borderColor: state.isDisabled ? '#ccc' : provided.borderColor,
                    //     cursor: state.isDisabled ? 'not-allowed' : 'default',
                    //     opacity: 1,
                    //     pointerEvents: state.isDisabled ? 'auto' : 'auto',
                    //   }),
                    // }}
                    styles={selectStyleDisable}
                  />

                  <label><span className="required">*</span>Gender</label>
                  {errors.gender && <p className="error">{errors.gender}</p>}
                </div>
              </div>
              <div className="personaldetails-container-part">
                <div className={`personaldetails-floating-label-container-2 ${isFocused.dateOfBirth || !!personalData.dateOfBirth ? 'float-label' : ''}`}>
                  <DatePicker
                    selected={personalData.dateOfBirth ? new Date(personalData.dateOfBirth) : null}
                    onChange={(date) => {
                      const formatted = date ? date.toISOString().split('T')[0] : '';
                      handleInputChange({ target: { name: 'dateOfBirth', value: formatted } });
                    }}
                    dateFormat="dd-MM-yyyy"
                    placeholderText=""
                    className="did-floating-input"
                    onFocus={() => setIsFocused(prev => ({ ...prev, dateOfBirth: true }))}
                    onBlur={() => setIsFocused(prev => ({ ...prev, dateOfBirth: false }))}
                    ref={dateInputRef}
                    minDate={new Date(minDate)}
                    maxDate={new Date(maxDate)}
                    disabled
                  />
                  <label><span className="required">*</span>Date of Birth</label>
                  {errors.dateOfBirth && <p className="error">{errors.dateOfBirth}</p>}
                </div>
              </div>
            </div>
            <div className="personaldetails-maincontainer">
              <div className="personaldetails-container-part">
                <div className="personaldetails-floating-label-container-2">
                  <input
                    type="text"
                    name="contactNumber"
                    value={personalData.contactNumber}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (onlyDigits(value)) {
                        handleInputChange(e);
                      }
                    }}
                    placeholder=" "
                    required
                    maxLength="10"
                    pattern="^[0-9]{10}$"
                    title="Please enter a valid 10-digit phone number."
                    disabled
                  />
                  <label><span className="required">*</span>Contact Number</label>
                  {errors.contactNumber && <p className="error">{errors.contactNumber}</p>}
                </div>
              </div>
              <div className="personaldetails-container-part">
                <div className="personaldetails-floating-label-container-1">
                  <input
                    type="email"
                    name="emailAddress"
                    value={personalData.emailAddress}
                    onChange={handleInputChange}
                    placeholder=" "
                    required
                    disabled
                  />
                  <label><span className="required">*</span>Email</label>
                  {errors.emailAddress && <p className="error">{errors.emailAddress}</p>}
                </div>
              </div>
            </div>
            <div className="personaldetails-maincontainer">
              <div className="personaldetails-container-part">
                <div className="personaldetails-floating-label-container-2">
                  <input
                    type="text"
                    name="fatherGivenName"
                    value={personalData.fatherGivenName}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (isAlphabet(value)) {
                        const updatedValue = capitalizeFirstLetter(value);
                        handleInputChange({ target: { name: "fatherGivenName", value: updatedValue } });
                      }
                    }}
                    placeholder=" "
                    required
                    disabled={isFieldDisabled}
                  />
                  <label><span className="required">*</span>Father Given Name</label>
                  {/* {errors.fatherGivenName && <p className="error">{errors.fatherGivenName}</p>} */}
                </div>
              </div>
              <div className="personaldetails-container-part">
                <div className="personaldetails-floating-label-container-1">
                  <input
                    type="text"
                    name="fatherSurname"
                    value={personalData.fatherSurname}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (isAlphabet(value)) {
                        const updatedValue = capitalizeFirstLetter(value);
                        handleInputChange({ target: { name: "fatherSurname", value: updatedValue } });
                      }
                    }}
                    placeholder=" "
                    required
                    disabled={isFieldDisabled}
                  />
                  <label><span className="required">*</span>Father Surname</label>
                  {/* {errors.fatherSurname && <p className="error">{errors.fatherSurname}</p>} */}
                </div>
              </div>
            </div>
            <div className="personaldetails-maincontainer">
              <div className="personaldetails-container-part">
                <div className="personaldetails-floating-label-container-2">
                  <input
                    type="text"
                    name="motherGivenName"
                    value={personalData.motherGivenName}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (isAlphabet(value)) {
                        const updatedValue = capitalizeFirstLetter(value);
                        handleInputChange({ target: { name: "motherGivenName", value: updatedValue } });
                      }
                    }}
                    placeholder=" "
                    required
                    disabled={isFieldDisabled}
                  />
                  <label><span className="required">*</span>Mother Given Name</label>
                  {/* {errors.motherGivenName && <p className="error">{errors.motherGivenName}</p>} */}
                </div>
              </div>
              <div className="personaldetails-container-part">
                <div className="personaldetails-floating-label-container-1">
                  <input
                    type="text"
                    name="motherSurname"
                    value={personalData.motherSurname}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (isAlphabet(value)) {
                        const updatedValue = capitalizeFirstLetter(value);
                        handleInputChange({ target: { name: "motherSurname", value: updatedValue } });
                      }
                    }}
                    placeholder=" "
                    required
                    disabled={isFieldDisabled}
                  />
                  <label><span className="required">*</span>Mother Surname</label>
                  {/* {errors.motherSurname && <p className="error">{errors.motherSurname}</p>} */}
                </div>
              </div>
            </div>
            <div className="personaldetails-maincontainer">
              <div className="personaldetails-container-part">
                <div className="personaldetails-floating-label-container-2">
                  <input
                    type="text"
                    name="fatherContactNumber"
                    value={personalData.fatherContactNumber}
                    onChange={(e) => {
                      const value = e.target.value;

                      // Allow only digits up to 10
                      if (onlyDigits(value)) {
                        handleInputChange(e);

                        // Live validation for mobile number
                        if (value.length === 10 && !validateMobile(value)) {
                          setErrors((prev) => ({
                            ...prev,
                            fatherContactNumber: "Mobile number must start with 6, 7, 8, or 9",
                          }));
                        } else {
                          // Clear error if valid or incomplete
                          setErrors((prev) => ({
                            ...prev,
                            fatherContactNumber: "",
                          }));
                        }
                      }
                    }}
                    placeholder=" "
                    maxLength="10"
                    pattern="^[0-9]{10}$"
                    title="Please enter a valid 10-digit phone number."
                    disabled={isFieldDisabled}
                  />
                  <label>Father Contact Number</label>
                  {errors.fatherContactNumber && <p className="error">{errors.fatherContactNumber}</p>}
                </div>
              </div>
              <div className="personaldetails-container-part">
                <div className="personaldetails-floating-label-container-2">
                  <input
                    type="text"
                    name="motherContactNumber"
                    value={personalData.motherContactNumber}
                    onChange={(e) => {
                      const value = e.target.value;

                      // Allow only digits up to 10
                      if (onlyDigits(value)) {
                        handleInputChange(e);

                        // Live validation for mobile number
                        if (value.length === 10 && !validateMobile(value)) {
                          setErrors((prev) => ({
                            ...prev,
                            motherContactNumber: "Mobile number must start with 6, 7, 8, or 9",
                          }));
                        } else {
                          // Clear error if valid or incomplete
                          setErrors((prev) => ({
                            ...prev,
                            motherContactNumber: "",
                          }));
                        }
                      }
                    }}
                    placeholder=" "
                    maxLength="10"
                    pattern="^[0-9]{10}$"
                    title="Please enter a valid 10-digit phone number."
                    disabled={isFieldDisabled}
                  />
                  <label>Mother Contact Number</label>
                  {errors.motherContactNumber && <p className="error">{errors.motherContactNumber}</p>}
                </div>
              </div>
            </div>
            <div className="personaldetails-maincontainer">
              <div className="personaldetails-container-part">
                <div className={`personaldetails-floating-label-container-2 ${isFocused.maritalStatus || !!personalData.maritalStatus ? 'float-label' : ''}`}>
                  <Select
                    name="maritalStatus"
                    options={maritalStatuses}
                    value={maritalStatuses.find(opt => opt.value === personalData.maritalStatus) || null}
                    onChange={(selectedOption) => handleInputChange(selectedOption, 'maritalStatus')}
                    onFocus={() => setIsFocused(prev => ({ ...prev, maritalStatus: true }))}
                    onBlur={() => setIsFocused(prev => ({ ...prev, maritalStatus: false }))}
                    placeholder=" "
                    isClearable
                    // styles={{
                    //   menuPortal: base => ({ ...base, zIndex: 9999, position: 'absolute', top: 'auto', bottom: '100%' }),
                    //   menu: base => ({ ...base, marginTop: '5px', zIndex: 9999 }),
                    //   control: provided => ({ ...provided, padding: '1px' }),
                    //   valueContainer: provided => ({ ...provided, padding: '3px 6px' }),
                    // }}
                    //styles={selectStyles}
                    isDisabled={isFieldDisabled}
                    styles={isFieldDisabled ? selectStyleDisable : selectStyles}
                  />
                  <label><span className="required">*</span>Marital Status</label>
                  {/* {errors.maritalStatus && <p className="error">{errors.maritalStatus}</p>} */}
                </div>
              </div>
              <div className="personaldetails-container-part"></div>
            </div>
            {isMaleAndMarried && (
              <>
                <div className="personaldetails-maincontainer">
                  <div className="personaldetails-container-part">
                    <div className="personaldetails-floating-label-container-2">
                      <input
                        type="text"
                        name="wifeName"
                        value={personalData.wifeName}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (isAlphabet(value)) {
                            const updatedValue = capitalizeFirstLetter(value);
                            handleInputChange({ target: { name: "wifeName", value: updatedValue } });
                          }
                        }}
                        placeholder=" "
                        required
                        disabled={isFieldDisabled}

                      />
                      <label><span className="required">*</span>Wife Given Name</label>
                      {errors.wifeName && <p className="error">{errors.wifeName}</p>}
                    </div>
                  </div>
                  <div className="personaldetails-container-part">
                    <div className="personaldetails-floating-label-container-1">
                      <input
                        type="text"
                        name="wifeSurname"
                        value={personalData.wifeSurname}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (isAlphabet(value)) {
                            const updatedValue = capitalizeFirstLetter(value);
                            handleInputChange({ target: { name: "wifeSurname", value: updatedValue } });
                          }
                        }}
                        placeholder=" "
                        required
                        disabled={isFieldDisabled}
                      />
                      <label><span className="required">*</span>Wife Surname</label>
                      {errors.wifeSurname && <p className="error">{errors.wifeSurname}</p>}
                    </div>
                  </div>
                </div>
                <div className="personaldetails-maincontainer">
                  <div className="personaldetails-container-part">
                    <div className="personaldetails-floating-label-container-1">
                      <input
                        type="text"
                        name="wifeContactNumber"
                        value={personalData.wifeContactNumber}
                        onChange={(e) => {
                          const value = e.target.value;

                          // Allow only digits up to 10
                          if (onlyDigits(value)) {
                            handleInputChange(e);

                            // Live validation for mobile number
                            if (value.length === 10 && !validateMobile(value)) {
                              setErrors((prev) => ({
                                ...prev,
                                wifeContactNumber: "Mobile number must start with 6, 7, 8, or 9",
                              }));
                            } else {
                              // Clear error if valid or incomplete
                              setErrors((prev) => ({
                                ...prev,
                                wifeContactNumber: "",
                              }));
                            }
                          }
                        }}
                        placeholder=" "
                        maxLength="10"
                        pattern="^[0-9]{10}$"
                        title="Please enter a valid 10-digit phone number."
                        disabled={isFieldDisabled}
                      />
                      <label>Wife Contact Number</label>
                      {errors.wifeContactNumber && <p className="error">{errors.wifeContactNumber}</p>}
                    </div>
                  </div>
                  <div className="personaldetails-container-part"></div>
                </div>
              </>
            )}
            {isFemaleAndMarried && (
              <>
                <div className="personaldetails-maincontainer">
                  <div className="personaldetails-container-part">
                    <div className="personaldetails-floating-label-container-2">
                      <input
                        type="text"
                        name="husbandName"
                        value={personalData.husbandName}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (isAlphabet(value)) {
                            const updatedValue = capitalizeFirstLetter(value);
                            handleInputChange({ target: { name: "husbandName", value: updatedValue } });
                          }
                        }}
                        placeholder=" "
                        required
                        disabled={isFieldDisabled}
                      />
                      <label><span className="required">*</span>Husband Given Name</label>
                      {errors.husbandName && <p className="error">{errors.husbandName}</p>}
                    </div>
                  </div>
                  <div className="personaldetails-container-part">
                    <div className="personaldetails-floating-label-container-1">
                      <input
                        type="text"
                        name="husbandSurname"
                        value={personalData.husbandSurname}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (isAlphabet(value)) {
                            const updatedValue = capitalizeFirstLetter(value);
                            handleInputChange({ target: { name: "husbandSurname", value: updatedValue } });
                          }
                        }}
                        placeholder=" "
                        required
                        disabled={isFieldDisabled}
                      />
                      <label><span className="required">*</span>Husband Surname</label>
                      {errors.husbandSurname && <p className="error">{errors.husbandSurname}</p>}
                    </div>
                  </div>
                </div>
                <div className="personaldetails-maincontainer">
                  <div className="personaldetails-container-part">
                    <div className="personaldetails-floating-label-container-1">
                      <input
                        type="text"
                        name="husbandContactNumber"
                        value={personalData.husbandContactNumber}
                        // onChange={(e) => {
                        //   const value = e.target.value;
                        //   if (onlyDigits(value)) {
                        //     handleInputChange(e);
                        //   }
                        // }}
                        onChange={(e) => {
                          const value = e.target.value;

                          // Allow only digits up to 10
                          if (onlyDigits(value)) {
                            handleInputChange(e);

                            // Live validation for mobile number
                            if (value.length === 10 && !validateMobile(value)) {
                              setErrors((prev) => ({
                                ...prev,
                                husbandContactNumber: "Mobile number must start with 6, 7, 8, or 9",
                              }));
                            } else {
                              // Clear error if valid or incomplete
                              setErrors((prev) => ({
                                ...prev,
                                husbandContactNumber: "",
                              }));
                            }
                          }
                        }}
                        placeholder=" "
                        maxLength="10"
                        pattern="^[0-9]{10}$"
                        title="Please enter a valid 10-digit phone number."
                        disabled={isFieldDisabled}
                      />
                      <label>Husband Contact Number</label>
                      {errors.husbandContactNumber && <p className="error">{errors.husbandContactNumber}</p>}
                    </div>
                  </div>
                  <div className="personaldetails-container-part"></div>
                </div>
              </>
            )}
            <div className="personaldetails-maincontainer">
              <div className="personaldetails-container-part">
                <div className={`personaldetails-floating-label-container-2 ${isFocused.nationality || !!personalData.nationality ? 'float-label' : ''}`}>
                  <Select
                    name="nationality"
                    options={nationalities}
                    value={nationalities.find(opt => opt.value === personalData.nationality) || null}
                    onChange={(selectedOption) => handleInputChange(selectedOption, 'nationality')}
                    onFocus={() => setIsFocused(prev => ({ ...prev, nationality: true }))}
                    onBlur={() => setIsFocused(prev => ({ ...prev, nationality: false }))}
                    placeholder=" "
                    isClearable
                    menuPortalTarget={document.body}
                    // styles={{
                    //   menuPortal: base => ({ ...base, zIndex: 9999 }),
                    //   control: provided => ({ ...provided, padding: '1px' }),
                    //   valueContainer: provided => ({ ...provided, padding: '3px 6px' }),
                    // }}
                    // styles={selectStyles}
                    isDisabled={isFieldDisabled}
                    styles={isFieldDisabled ? selectStyleDisable : selectStyles}
                  />


                  <label><span className="required">*</span>Nationality</label>
                  {/* {errors.nationality && <p className="error">{errors.nationality}</p>} */}
                </div>
              </div>
              <div className="personaldetails-container-part">
                <div className={`personaldetails-floating-label-container-2 ${isFocused.religion || !!personalData.religion ? 'float-label' : ''}`}>
                  <Select
                    name="religion"
                    options={religions}
                    value={religions.find(opt => opt.value === personalData.religion) || null}
                    onChange={(selectedOption) => handleInputChange(selectedOption, 'religion')}
                    onFocus={() => setIsFocused(prev => ({ ...prev, religion: true }))}
                    onBlur={() => setIsFocused(prev => ({ ...prev, religion: false }))}
                    placeholder=" "
                    isClearable
                    menuPortalTarget={document.body}
                    // styles={{
                    //   menuPortal: base => ({ ...base, zIndex: 9999 }),
                    //   control: provided => ({ ...provided, padding: '1px' }),
                    //   valueContainer: provided => ({ ...provided, padding: '3px 6px' }),
                    // }}
                    // styles={selectStyles}
                    isDisabled={isFieldDisabled}
                    styles={isFieldDisabled ? selectStyleDisable : selectStyles}
                  />
                  <label><span className="required">*</span>Religion</label>
                  {/* {errors.religion && <p className="error">{errors.religion}</p>} */}
                </div>
              </div>
            </div>
            <div className="personaldetails-maincontainer">
              <div className="personaldetails-container-part">
                <div className={`personaldetails-floating-label-container-2 ${isFocused.category || !!personalData.category ? 'float-label' : ''}`}>
                  <Select
                    name="category"
                    options={categories}
                    value={categories.find(opt => opt.value === personalData.category) || null}
                    onChange={(selectedOption) => handleInputChange(selectedOption, 'category')}
                    onFocus={() => setIsFocused(prev => ({ ...prev, category: true }))}
                    onBlur={() => setIsFocused(prev => ({ ...prev, category: false }))}
                    placeholder=" "
                    isClearable
                    menuPortalTarget={document.body}
                    // styles={{
                    //   menuPortal: base => ({ ...base, zIndex: 9999 }),
                    //   control: provided => ({ ...provided, padding: '1px' }),
                    //   valueContainer: provided => ({ ...provided, padding: '3px 6px' }),
                    // }}
                    // styles={selectStyles}
                    isDisabled={isFieldDisabled}
                    styles={isFieldDisabled ? selectStyleDisable : selectStyles}
                  />
                  <label><span className="required">*</span>Reservation Category</label>
                  {/* {errors.category && <p className="error">{errors.category}</p>} */}
                </div>
              </div>
              <div className="personaldetails-container-part">
                {personalData.category && (() => {
                  const selectedCategory = categories.find(cat => cat.value === personalData.category);
                  const label = selectedCategory?.label?.toUpperCase();

                  const creamyLayerCategories = ['BC', 'BC-I', 'BC-II', 'EBC', 'EBC-I', 'EBC-II'];

                  return creamyLayerCategories.includes(label) ? (

                    <div className="personaldetails-input-container-radio">
                      <label><span className="required">*</span> Non-Creamy Layer:</label>

                      <label>
                        <input
                          type="radio"
                          name="isCreamyLayer"
                          value="true"                      
                          checked={personalData.isCreamyLayer === "true" || personalData.isCreamyLayer === true}
                          onChange={handleInputChange}
                          disabled={isFieldDisabled}
                        />
                        &nbsp; Yes 
                      </label>

                      <label>
                        <input
                          type="radio"
                          name="isCreamyLayer"
                           value="false"                     
                          checked={personalData.isCreamyLayer === "false" || personalData.isCreamyLayer === false}
                          onChange={handleInputChange}
                          disabled={isFieldDisabled}
                        />
                        &nbsp; No
                      </label>

                      {errors.isCreamyLayer && <p className="error">{errors.isCreamyLayer}</p>}
                    </div>

                  ) : null;
                })()}
              </div>
            </div>
            <div className="personaldetails-maincontainer">
              <div className="personaldetails-container-part">
                <div className="personaldetails-input-container-radio">
                  <label>Physically Handicapped:</label>
                  <label>
                    <input
                      type="radio"
                      name="physicallyHandicapped"
                      value="true"
                      checked={personalData.physicallyHandicapped === "true" || personalData.physicallyHandicapped === true}
                      onChange={handleInputChange}
                      disabled={isFieldDisabled}
                    />&nbsp; Yes
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="physicallyHandicapped"
                      value="false"
                      checked={personalData.physicallyHandicapped === "false" || personalData.physicallyHandicapped === false}
                      onChange={handleInputChange}
                      disabled={isFieldDisabled}
                    />&nbsp; No
                  </label>
                  {errors.physicallyHandicapped && <p className="error">{errors.physicallyHandicapped}</p>}
                </div>
              </div>
              <div className="personaldetails-container-part">
                <div className="personaldetails-input-container-radio">
                  <label>Hearing Problem:</label>
                  <label>
                    <input
                      type="radio"
                      name="hearingProblem"
                      value="true"
                      checked={personalData.hearingProblem === "true" || personalData.hearingProblem === true}
                      onChange={handleInputChange}
                      disabled={isFieldDisabled}
                    />&nbsp; Yes
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="hearingProblem"
                      value="false"
                      checked={personalData.hearingProblem === "false" || personalData.hearingProblem === false}
                      onChange={handleInputChange}
                      disabled={isFieldDisabled}
                    />&nbsp; No
                  </label>
                  {errors.hearingProblem && <p className="error">{errors.hearingProblem}</p>}
                </div>
              </div>
              {/* <div className="personaldetails-container-part">
                <div className="personaldetails-input-container-radio">
                  <label>Visual Problem:</label>
                  <label>
                    <input
                      type="radio"
                      name="visualProblem"
                      value="true"
                      checked={personalData.visualProblem === "true" || personalData.visualProblem === true}
                      onChange={handleInputChange}
                      disabled={isFieldDisabled}
                    />&nbsp; Yes
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="visualProblem"
                      value="false"
                      checked={personalData.visualProblem === "false" || personalData.visualProblem === false}
                      onChange={handleInputChange}
                      disabled={isFieldDisabled}
                    />&nbsp; No
                  </label>
                  {errors.visualProblem && <p className="error">{errors.visualProblem}</p>}
                </div>
              </div> */}
            </div><div className="personaldetails-maincontainer">
              {/* <div className="personaldetails-container-part">
                <div className="personaldetails-input-container-radio">
                  <label>Hearing Problem:</label>
                  <label>
                    <input
                      type="radio"
                      name="hearingProblem"
                      value="true"
                      checked={personalData.hearingProblem === "true" || personalData.hearingProblem === true}
                      onChange={handleInputChange}
                      disabled={isFieldDisabled}
                    />&nbsp; Yes
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="hearingProblem"
                      value="false"
                      checked={personalData.hearingProblem === "false" || personalData.hearingProblem === false}
                      onChange={handleInputChange}
                      disabled={isFieldDisabled}
                    />&nbsp; No
                  </label>
                  {errors.hearingProblem && <p className="error">{errors.hearingProblem}</p>}
                </div>
              </div> */}
              <div className="personaldetails-container-part">
                <div className="personaldetails-input-container-radio">
                  <label>Visual Problem:</label>
                  <label>
                    <input
                      type="radio"
                      name="visualProblem"
                      value="true"
                      checked={personalData.visualProblem === "true" || personalData.visualProblem === true}
                      onChange={handleInputChange}
                      disabled={isFieldDisabled}
                    />&nbsp; Yes
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="visualProblem"
                      value="false"
                      checked={personalData.visualProblem === "false" || personalData.visualProblem === false}
                      onChange={handleInputChange}
                      disabled={isFieldDisabled}
                    />&nbsp; No
                  </label>
                  {errors.visualProblem && <p className="error">{errors.visualProblem}</p>}
                </div>
              </div>
            </div>
            <div className="personaldetails-btn-div">
              <button type="submit" className="personaldetails-btn" disabled={!isFormValid}>Save & Next</button>
            </div>
          </form>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PersonalDetails;